module.exports = __webpack_public_path__ + "img/openbadge-type-4.6f35d5fe.png";